//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: 'tip',
      validator: (v) => ['tip', 'warning', 'info', 'danger'].includes(v)
    }
  },
  computed: {
    icon() {
      const icons = {
        tip: 'fas fa-lightbulb',
        warning: 'fas fa-exclamation-triangle',
        info: 'fas fa-info-circle',
        danger: 'fas fa-times-circle'
      };
      return icons[this.type] || icons.info;
    }
  }
};
